<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Уведомления</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте проверим настройка уведомлений проекта.</p>

            <p>
              В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Данные проекта&raquo;. На&nbsp;появившейся странице
              выберите &laquo;Уведомления&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="aktivnost-uvedomleniy"
            class="typography__headline2"
          >
            Активность уведомлений
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>В&nbsp;основной информации раздела можно увидеть куда будут приходить уведомления вне CRM MyDonut.</p>

            <p>
              Активность уведомлений по-умолчанию включена для всех видов. Проверьте, возможно понадобится что-то
              изменить.
            </p>

            <p>
              После изменений нажмите &laquo;Сохранить&raquo; в&nbsp;самом низу страницы. После успешного сохранения
              увидите в&nbsp;правом верхнем углу уведомление.
            </p>

            <p>
              С&nbsp;уведомлениями разобрались. Теперь можно перейти к&nbsp;настройке
              <BaseLink
                target="_blank"
                to="/faq/categories/sotrudniki"
                >сотрудников</BaseLink
              >,

              <BaseLink
                target="_blank"
                to="/faq/categories/onlayn-zapis"
                >услуг</BaseLink
              >

              или
              <BaseLink
                target="_blank"
                to="/faq/categories/zakazy-s-tovarami"
                >товаров</BaseLink
              >.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Данные проекта",
    url: "/faq/categories/dannyye-proyekta",
  },
  {
    name: "Уведомления",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Активность&nbsp;уведомлений",
    url: "aktivnost-uvedomleniy",
  },
];

const relatedArticles = [
  {
    name: "Настройка меню CRM",
    slug: "nastroyka-menyu-crm",
  },
  {
    name: "Общие настройки",
    slug: "obshchiye-nastroyki",
  },
  {
    name: "Контакты и&nbsp;данные филиалов",
    slug: "kontakty-i-dannye-filialov",
  },
  {
    name: "Язык и&nbsp;регион",
    slug: "yazyk-i-region",
  },
];

useSeoMeta({
  title: "Уведомления",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

p a {
  display: contents;
}
</style>
